export default {
  tableDataStockistRegistration: state => {
    return state.stockistRegistrationList
  },
  tableDataStockistConsignmentDeposit: state => {
    return state.stockistConsignmentDepositList
  },
  tableDataStockistOrderReturnList: state => {
    return state.stockistOrderReturnList
  },
  tableDataStockistDepositRefundList: state => {
    return state.stockistDepositRefundList
  },
  tableDataStockistDailyTransactionList: state => {
    return state.stockistDailyTransactionList
  },
  tableDataStockistARSummaryList: state => {
    return state.stockistARSummaryList
  },
  getConsignmentBalanceCalculationStatus: state => {
    return state.stockistConsignmentBalanceCalculationStatus.data
  },
}
